import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Button = ({
  children,
  color,
  disabled,
  onClick,
  ...rest
}) => (
  <button
    className={`Button Button-${color}`}
    type="button"
    disabled={disabled}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  color: 'blue',
  disabled: false,
  onClick: () => {},
};

export default Button;
